/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { NumberAndAlphabetComparator } from '../../../../../SharedModules/utilities/utilities';
import { getDateInMMDDYYYYFormat } from '../../../../../SharedModules/DateUtilities/DateUtilities';
const dateValueFormatter = (params) =>
  getDateInMMDDYYYYFormat(params.value) || '';
 
const dateExportOption = {
  exportOption: {
    enableValueFormatter: true,
  },
};
function monthToComparableNumber(date) {
  
  if (date === undefined || date === null || date === '') {
    return null;
  }

  const normalizedDate = moment(date);
  if (normalizedDate.isValid()) {
    return (
      normalizedDate.year() * 10000 +
      (normalizedDate.month() + 1) * 100 +
      normalizedDate.date()
    );
  }

  if (typeof date === 'string') {
    const stringDate = date.trim();
    if (stringDate.length !== 10) {
      return null;
    }

    const yearNumber = Number.parseInt(stringDate.substring(6, 10));
    const dayNumber = Number.parseInt(stringDate.substring(3, 5));
    const monthNumber = Number.parseInt(stringDate.substring(0, 2));
    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
  }

  return null;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}

function amountComparator(amount1, amount2) {
  if (amount1 === null && amount2 === null) {
    return 0;
  }
  if (amount1 === null) {
    return -1;
  }
  if (amount2 === null) {
    return 1;
  }

  return amount1 - amount2;
}

export const logCheckTableHead = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_160,
    // maxWidth: Styles.Width_200,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Number',
    field: 'batchNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'BatchNumCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellClass:"editableInput",
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Date',
    field: 'batchDt',
    comparator: dateComparator,
    valueFormatter: dateValueFormatter,
    ...dateExportOption,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'BatchDateCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agDateColumnFilter',
    valueFormatter: (params) =>
      params.value
      ? moment(params.value).format('MM/DD/YYYY')
      : '',
    filterParams: {
      comparator: dateComparator,
      defaultOption: 'equals',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CCN',
    field: 'checkIdentifier',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckIdentifierCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckNumCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    editable: false,
    sortable: true,
    cellClass: 'frr-checkissuerField',
    required: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckIssuerCellRender',
    comparator: NumberAndAlphabetComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Information',
    field: 'checkInfo',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    columnSpan: 4,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckInfoCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Check Date',
    field: 'checkDt',
    comparator: dateComparator,
    valueFormatter: dateValueFormatter,
    ...dateExportOption,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckDateCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: dateComparator,
      defaultOption: 'equals',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmark/ EFT Transmittal Date',
    field: 'postmarkedDt',
    comparator: dateComparator,
    valueFormatter: dateValueFormatter,
    ...dateExportOption,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'PostMarkedDateCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: dateComparator,
      defaultOption: 'equals',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    comparator: dateComparator,
    valueFormatter: dateValueFormatter,
    ...dateExportOption,
    editable: false,
    sortable: true,
    suppressMenu: false,
    required: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ReceivedDateCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: dateComparator,
      defaultOption: 'equals',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    required: true,
    cellClass: 'frr-Checkamt-log',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    exportZeroesTwo: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckAmtCellRender',
    printPrefixValue: '$ ',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    required: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckPayeeCDCellRender',
    showDropDownVal: true,
    dropDownValueCol: 'checkPayeeCdValWithLabel',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Payment Type',
    field: 'paymentMediaTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'PaymentMediaTypeCDCellRender',
    showDropDownVal: true,
    dropDownValueCol: 'paymentMediaTypeCdValWithLabel',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Dispute Resolution',
    field: 'disputeResolutionCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputeResolutionCDCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    showDropDownVal: true,
    dropDownValueCol: 'disputeResolutionCdValWithLabel',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export function DropdownActions(props) {
  const { generalSystemParameterDetails, logBatchTotalScreen, deleteAction } =
    props;

  const [anchorEl, setAnchorEl] = React.useState();
  const [open, setOpen] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        className="frr-check-export-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <SVGComponent iconName="Icon-export" />
      </IconButton>

      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="export_dropdown"
      >
        <MenuItem
          role="button"
          onClick={() => {
            if (
              generalSystemParameterDetails?.length > 0 &&
              parseInt(
                generalSystemParameterDetails[0].checkLogUsesBatchInd,
                [0, 1]
              ) === 1
            ) {
              handleClose();
              logBatchTotalScreen();
            }
          }}
        >
          View Batch Totals
        </MenuItem>
        <MenuItem
          role="button"
          onClick={() => {
            handleClose();
            deleteAction();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  );
}
